import { hc, type ClientResponse } from 'hono/client'
import type { AppType } from 'gasrail-api'

// End-to-end typed client: request params and response bodies come straight from the API's route definitions.
export const api = hc<AppType>('/').api

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message)
  }
}

type Ok<R> = R extends ClientResponse<infer T, infer S, any> ? (S extends 200 | 201 ? T : never) : never

export async function call<R extends ClientResponse<any, any, any>>(req: Promise<R>): Promise<Ok<R>> {
  let res: R
  try {
    res = await req
  } catch {
    throw new ApiError("Can't reach GasRail. Check your connection and try again.", 0)
  }
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiError((body as { error?: string }).error ?? `Request failed (${res.status})`, res.status)
  return body as Ok<R>
}
